import { Box } from "@chakra-ui/react";
import { useInvoiceDetailStore } from "../../store";
import { FileItem } from "./FileItem";

export const FilesList = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.filesToAttach.length) return null;

  return (
    <Box flexWrap="wrap">
      {store.invoice.filesToAttach.map((f) => (
        <FileItem
          key={f.public_id}
          mr="2"
          mb="2"
          fileName={f.filename}
          url={f.urls.original}
        />
      ))}
    </Box>
  );
};
